import { forwardRef, HtmlHTMLAttributes, memo } from "react";
import classNames from "classnames";

import styles from "./style.module.scss"

export type CommandMenuHeaderSize = "sm" | "md"

export type CommandMenuHeaderProps = {
  size?: CommandMenuHeaderSize
} & HtmlHTMLAttributes<HTMLDivElement>

export const CommandMenuHeader = memo(forwardRef<HTMLDivElement, CommandMenuHeaderProps>((
  {
    size,
    children,
    className,
    ...props
  }, ref) => {
  return (
    <div
      className={classNames(
        className,
        styles.root,
        styles[size as keyof typeof styles]
      )}
      {...props}
      ref={ref}
    >
      {children}
    </div>
  );
}));